<template>
  <div>
    <el-table :data="tableOrderInfo" border>
      <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
      <el-table-column prop="operation" label="状态" align="center"></el-table-column>
      <el-table-column prop="createTime" label="操作时间" align="center"></el-table-column>
      <el-table-column prop="reqReason" label="备注" align="center"></el-table-column>
      <el-table-column prop="operator" label="操作人" align="center"></el-table-column>
    </el-table>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>

</template>
<script>
import {cardRemovalOperation} from "@/api/api.js"; //操作记录
export default {
  props: {
    iccid: {
      type: [String]
    }
  },
  data() {
    return{
      tableOrderInfo:[],
      page: 1,
      pageSize: 10,
      total:0,
    }
  },
  watch: {
    iccid() {
      this.initData();
    }
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  methods: {
    // 获操操作列表的数据
    initData(){
      let params = {
        model: this.iccid,
        page: this.page,
        pageSize: this.pageSize,
      };
      cardRemovalOperation(params).then(res =>{
        if(res.data.code == 200){
          this.tableOrderInfo = res.data.data.records;
          this.total = res.data.data.total;
          this.tableOrderInfo.map((item,index)=>{
            item.ids = index + 1;
            if(item.reqReason == "null"){
              item.reqReason = "-"
            }
          });
          this.tableOrderInfo.sort(this.compare('id'));
        }
      })
    },
    // 排序
    compare(property){
      return function(a,b){
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
      }
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
  },
  created() {
  }
};
</script>

<style scoped lang="less">

</style>


